/* build/tpl */
import deps from './deps/mapDeep.js';
import getMapDeep from './getMapDeep.js';
export default getMapDeep(deps);
